import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-walk-icon',
  templateUrl: './walk-icon.component.html',
  styleUrls: ['./walk-icon.component.scss']
})
export class WalkIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
